module.exports = "/assets/323b35466811ce17d2e6e868366d0e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JE.png
// module id = 1507
// module chunks = 0